<template>
  <div v-if="dialogVisible">
    <el-dialog :title="type ==='edit' ? $t('lang.Button.edit') : $t('lang.Button.Add')" :visible.sync="dialogVisible" width="40%" center>
      <div class="form">
        <el-form label-width="150px">
          <el-form-item :label="`${$t('lang.smartlink.enable')}：`" prop="name">
            <el-checkbox v-model="modeForm.enabled"></el-checkbox>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.uplink')}：`">
            <el-row v-for="(item, index) in modeForm.uplink" :key="index">
              <el-col :span="20">
                <el-input
                  v-model="modeForm.uplink[index]"
                  ref="uplink"
                  @blur="uplinkBlur(index)"
                  v-if="uplinkCustome[index] == true"
                  clearable
                  size="small"
                >
                </el-input>
                <el-select
                  v-else-if="uplinkCustome[index] == false"
                  :disabled="noSname === false ? false : true"
                  size="small"
                  v-model="modeForm.uplink[index]"
                  @change="(val) => uplinkChange(val, index)"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in linkOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-button v-if="index === modeForm.uplink.length -1" type="primary" size="mini" @click="addUplink">+</el-button>
                <el-button v-else @click="delUplink(index)" type="danger" size="mini">×</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.downlink')}：`">
            <el-row v-for="(item, index) in modeForm.downlink" :key="index">
              <el-col :span="20">
                 <el-input
                  v-model="modeForm.downlink[index]"
                  v-if="downlinkCustome[index]"
                  @blur="downlinkBlur(index)"
                  clearable
                  ref="downlink"
                  size="small"
                >
                </el-input>
                <el-select
                  v-else
                  :disabled="noSname === false ? false : true"
                  size="small"
                  v-model="modeForm.downlink[index]"
                  @change="(val) => downlinkChange(val, index)"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in linkOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-button v-if="index === modeForm.downlink.length -1" type="primary" size="mini" @click="addDowlink">+</el-button>
                <el-button v-else type="danger" size="mini">×</el-button>
              </el-col>
            </el-row>
           
          </el-form-item>
        </el-form>
      </div>

      <el-button
        type="danger"
        size="mini"
        class="Config-Buttom"
        @click="updateMode"
      >{{$t('lang.ConfigSetting.SaveApply')}}</el-button>
    </el-dialog>
  </div>
</template>
<script>
import { cloneDeep, isEqual } from "lodash";
import { updateConfig } from "@/api/configurationlist";
export default {
  props: ["deviceDid", "deviceSn", "linkOptions", "noSname"],
  data() {
    return {
      dialogVisible: false,
      modeForm: {
        enabled: "",
        uplink: [],
        downlink: []
      },
      type: "", //标记是编辑操作还是添加操作
      // 自定义
      uplinkCustome: [],
      downlinkCustome: [],
      // 记录修改第几个
      index: 0,
      // 原始数据，用来判断数据是否被修改，若没有进行修改点击保存不向设备发送修改请求
      originMode: {}
    };
  },
  methods: {
    clearData() {
      this.modeForm = {
        enabled: "",
        uplink: [],
        downlink: []
      };
      this.uplinkCustome = []
      this.downlinkCustome = []
    },
    show(item, index) {
      this.clearData();
      if (item) {
        // 编辑
        this.type = "edit";
        this.modeForm.enabled = item.enabled == "1" ? true : false;
        // 当上下行设备变为空的时候，要显示选择框
        if(item.uplink.length === 0) {
          this.modeForm.uplink.push('')
          this.uplinkCustome.push(false)
        }else{
          item.uplink.forEach((uplinkItem, uplinkIndex) => {
            this.linkOptions.forEach((ele, index) => {
              if(uplinkItem === ele.label) {
                this.modeForm.uplink[uplinkIndex] = ele.value
                this.uplinkCustome[uplinkIndex] = false
              }
            })
          })
        }
        if(item.downlink.length === 0) {
          this.modeForm.downlink.push('')
          this.downlinkCustome.push(false)
        }else{
          item.downlink.forEach((downlinkItem, downlinkIndex) => {
            this.linkOptions.forEach((ele, index) => {
              if(downlinkItem === ele.label) {
                this.modeForm.downlink[downlinkIndex] = ele.value
                this.downlinkCustome[downlinkIndex] = false
              }
            })
          })
        }
        this.index = index;
      } else {
        // 增加
        this.type = "add";
        this.index = index;
        // 显示空的下拉框
        this.modeForm.uplink.push('')
        this.uplinkCustome.push(false)
        this.modeForm.downlink.push('')
        this.downlinkCustome.push(false)
      }
      this.dialogVisible = true;
      this.originMode = cloneDeep(this.modeForm)
    },
    // 下行设备下拉框值发生变化
    downlinkChange(val, index) {
      if (val == "--自定义--") {
        // 若直接用 = 赋值，不会触发DOM重新渲染
        this.$set(this.downlinkCustome, index, true)
        this.modeForm.downlink[index] = ''
        this.$nextTick(() => {
          this.$refs.downlink[index].focus()
        })
      } else {
        this.$set(this.downlinkCustome, index, false)
      }
    },
    uplinkChange(val, index) {
      if (val == "--自定义--") {
        this.$set(this.uplinkCustome, index, true)
        this.modeForm.uplink[index] = ''
        // nextTick在更新后会执行，不使用nextTick会导致视图未更新focus方法出错
        this.$nextTick(() =>{
          this.$refs.uplink[index].focus()
        })
      } else {
        this.$set(this.uplinkCustome, index, false)
      }
    },
    // 上下行设备自定义输入框失去焦点后显示下拉框
    uplinkBlur(index) {
      this.$set(this.uplinkCustome, index, false)
    },
    downlinkBlur(index) {
      this.$set(this.downlinkCustome, index, false)
    },
    // 添加上行设备
    addUplink() {
      this.modeForm.uplink.push('')
      this.uplinkCustome.push(false)
    },
    // 删除上行设备
    delUplink(index) {
      this.modeForm.uplink.splice(index, 1)
    },
    // 添加下行设备
    addDowlink() {
      this.modeForm.downlink.push('')
      this.downlinkCustome.push(false)
    },
    // 删除下行设备
    delDownlink(index) {
      this.modeForm.downlink.splice(index, 1)
    },
    updateMode() {
      // 判断是否有数据被修改
      if(!isEqual(this.modeForm, this.originMode)){
        // 深拷贝，防止enabled值修改为数字后页面复选框直接渲染导致出错
        let copyData = cloneDeep(this.modeForm);        
        copyData.enabled = copyData.enabled == true ? "1" : "";
        let action = 0
        if (this.type === "edit") {
          action = 0
        }else if(this.type === 'add'){
          action = 1
        }
        let submitData = []
        // 没有noSname这个字段无法修改上下行设备，只能修改是否启用
        if(this.noSname === true) {
          submitData = [{
            section: "mode",
            config: "smartlink",
            action: action,
            index: [this.index],
            // server: "smartlink",
            options: {
                enabled: copyData.enabled
            },
          }]
        }else{
          submitData = [{
            section: "mode",
            config: "smartlink",
            action: action,
            index: [this.index],
            // server: "smartlink",
            options: {
                enabled: copyData.enabled
            },
            lists:{
              'uplink':copyData.uplink,
              'downlink':copyData.downlink
              }
          }]
        }
        updateConfig(this.deviceSn, this.deviceDid,submitData).then(res => {
          if(res.data.data.mess === 0) {
            this.$message.success(this.$t('lang.ConfigSetting.successSetting'))
            this.$emit('updateData')
            this.dialogVisible = false
          }else{
            this.$message.error(this.$t('lang.ConfigSetting.failSetting'))
          }
        })
      }else{
        this.dialogVisible = false
      }
    }
  }
};
</script>
<style scoped>
.Config-Buttom {
  display: table;
  margin: 30px auto;
  font-size: 14px;
  overflow: hidden;
}
.form {
  display: flex;
  justify-content: center;
}
</style>